module.exports = __webpack_public_path__ + "user/static/media/terms.9cffcad6.xhtml";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/shared/ModalTerms/terms.xhtml
// module id = 387
// module chunks = 38